/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumesubscription1Inputs */

const en_resumesubscription1 = /** @type {(inputs: Resumesubscription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume Subscription`)
};

const de_resumesubscription1 = /** @type {(inputs: Resumesubscription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement fortsetzen`)
};

/**
* | output |
* | --- |
* | "Resume Subscription" |
*
* @param {Resumesubscription1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const resumesubscription1 = /** @type {((inputs?: Resumesubscription1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumesubscription1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resumesubscription1(inputs)
	return de_resumesubscription1(inputs)
});
export { resumesubscription1 as "resumeSubscription" }